import styled from 'styled-components';

const NameTD = styled.td`
  max-width: 200px;
`;

export default NameTD;
